// hooks/useFilteredDocuments.js
import { useCallback, useMemo } from "react";

export const useFilteredDocuments = (data, startDate, endDate) => {
  const isArray = Array.isArray(data);

  const filterByDate = useCallback((docs) => {
    if (!startDate || !endDate) return docs;
    const start = new Date(startDate);
    const end = new Date(endDate);
    return docs.filter(doc => {
      const docDate = new Date(doc.fecha);
      return docDate >= start && docDate <= end;
    });
  },[endDate, startDate]);

  const padresActivos = useMemo(() => {
    return isArray
      ? filterByDate(data.filter(doc => doc?.activo))
          .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
      : [];
  }, [data, filterByDate, isArray]);

  const eliminados = useMemo(() => {
    return isArray
      ? filterByDate(data.filter(doc =>
          !doc.activo || doc.archivos?.some(file => !file.activo)
        )).sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
      : [];
  }, [data, filterByDate, isArray]);

  return { padresActivos, eliminados };
};
